import { Navigate } from 'react-router-dom';

import { useGetMeQuery } from '../../store/api/authApi';
import { isAuthenticated } from '../../utils/tokenManager';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

export default function ProtectedRoute({ children, requireAdmin = false }: ProtectedRouteProps) {
  const isAuth = isAuthenticated();
  const { data: userData, isLoading } = useGetMeQuery(undefined, {
    skip: !isAuth,
  });

  if (!isAuth) {
    return <Navigate to="/login" replace />;
  }

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-neutral-light">Loading...</div>
      </div>
    );
  }

  if (requireAdmin && !userData?.data?.user?.isAdmin) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

